// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ` {
  @import url('https://fonts.googleapis.com/css?family=Montserrat');
}

  @font-face {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 400;
    src:
      local('Roboto'),
      local('Roboto-Regular'),
      url(https://fonts.gstatic.com/s/roboto/v15/2UX7WLTfW3W8TclTUvlFyQ.woff)
        format('woff');
  }

  * {
    box-sizing: border-box;
  }

  *:before, *:after {
    box-sizing: border-box;
  }

  html {
    height: 100%;
  }

  html body {
      font-family: 'Roboto', sans-serif;
      background: #f6f6f7;
      justify-content: center;
      flex-direction: column;
      text-align: center;
      height: auto;
      margin: 0;
      position: relative;
      color: #1b2432;
    }

  input:-webkit-autofill, textarea:-webkit-autofill, select:-webkit-autofill {
    background-color: transparent !important;
    -webkit-box-shadow: 0 0 0 30px white inset;
    -webkit-text-fill-background-color: transparent !important;
  }

  input[type='text']:disabled {
    background: #f6f6f7;
    font-family: Roboto-Regular;
    font-size: 15px;
    color: #6d717a;
    opacity: 1 !important;
  }

  input[type='text'], input[type='password'], textarea, select {
    outline: none;
  }

  a {
    text-decoration: none;
    color: #000000;
  }

  h1 {
    font-size: 40px;
    font-weight: 300;
  }

  h2 {
    font-size: 17px;
    font-weight: 500;
    line-height: 20px;
    margin: 0;
  }

  .pageWrapper {
    text-align: left;
  }

  .pageWrapper.pageWrapperThin {
      margin: auto;
    }

  .pageWrapper.pageWrapperMid {
      max-width: 1120px;
      margin: auto;
    }

  .react-autosuggest__container {
    position: relative;
  }

  .react-autosuggest__suggestions-container {
    display: none;
  }

  .react-autosuggest__suggestions-container--open {
    display: block;
    position: absolute;
    z-index: 2;
    margin-top: 5px;
    box-shadow: none;
    border: 1px solid #c6c8cc;
    border-radius: 5px;
  }

  .react-autosuggest__suggestions-list {
    margin: 0;
    padding: 0;
    list-style-type: none;
  }

  .react-autosuggest__suggestion {
    cursor: pointer;
    display: block;
  }

  .success-message, .error-message {
    background-color: #1b2432 !important;
    color: #fff;
    font-size: 15px;
    padding: 13px 16px !important;
    min-width: 375px !important;
  }

  .success-message > div, .error-message > div {
      padding: 0 !important;
    }

  .success-message > div > span, .error-message > div > span {
        font-weight: 600 !important;
        font-size: 15px !important;
      }

  .success-message svg, .error-message svg {
      margin-right: 16px !important;
      width: 26px;
      height: 26px;
    }

  .success-message svg {
      color: #40e8af;
    }

  .error-message svg {
      color: red;
    }

  .recommendedItemContainer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
  }

  .recommended {
    background: rgba(18, 218, 159, 0.1);
    border: 1px solid #12da9f;
    border-radius: 4px;
    width: 105px !important;
    height: 24px;
    font-size: 13px;
    color: #1b2432;
    letter-spacing: 0;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .menuItem {
    display: flex;
    align-items: center;
  }

  .menuItem svg {
      margin-right: 5px !important;
      border: 1px solid #dddee0;
      border-radius: 50%;
    }

  .rc-color-picker {
    z-index: 99999 !important;
  }

  .rc-color-picker-panel {
    opacity: 1 !important;
    z-index: 99999 !important;
    background-color: white !important;
  }

  .rc-color-picker-panel-inner {
    background-color: white !important;
  }

  label[data-shrink='true'] {
    z-index: 1 !important;
  }

  .styled-scrollbars::-webkit-scrollbar {
      width: 8px;
      height: 8px;
    }

  .styled-scrollbars::-webkit-scrollbar-thumb {
      background-color: #e0e2e6;
      border-radius: 8px;
    }

  /* &::-webkit-scrollbar-track {
      background: #f6f6f7;
    } */

  .styled-scrollbars::-webkit-scrollbar-track-piece {
      background: transparent;
    }

  .styled-scrollbars::-webkit-resizer, .styled-scrollbars::-webkit-scrollbar-button, .styled-scrollbars::-webkit-scrollbar-corner {
      display: none;
    }

  .companyEmployeePopup .react-autosuggest__suggestions-list {
      max-height: 200px;
      overflow-y: auto;
      width: 305px;
    }
`, "",{"version":3,"sources":["webpack://./global-styles/global.pcss"],"names":[],"mappings":"AAAA;EACE,iEAAiE;AA6OnE;;EA3OE;IACE,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB;;;;sBAIkB;EACpB;;EAEA;IAGE,sBAAsB;EACxB;;EACA;IAIE,sBAAsB;EACxB;;EAEA;IACE,YAAY;EAYd;;EAXE;MACE,iCAAiC;MACjC,mBAAmB;MACnB,uBAAuB;MACvB,sBAAsB;MACtB,kBAAkB;MAClB,YAAY;MACZ,SAAS;MACT,kBAAkB;MAClB,cAAc;IAChB;;EAGF;IAGE,wCAAwC;IACxC,0CAA0C;IAC1C,0DAA0D;EAC5D;;EAEA;IACE,mBAAmB;IACnB,2BAA2B;IAC3B,eAAe;IACf,cAAc;IACd,qBAAqB;EACvB;;EAEA;IAIE,aAAa;EACf;;EAEA;IACE,qBAAqB;IACrB,cAAc;EAChB;;EAEA;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,eAAe;IACf,gBAAgB;IAChB,iBAAiB;IACjB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAUlB;;EARE;MACE,YAAY;IACd;;EAEA;MACE,iBAAiB;MACjB,YAAY;IACd;;EAGF;IACE,kBAAkB;EACpB;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,cAAc;IACd,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;EACpB;;EAEA;IACE,SAAS;IACT,UAAU;IACV,qBAAqB;EACvB;;EAEA;IACE,eAAe;IACf,cAAc;EAChB;;EAEA;IAEE,oCAAoC;IACpC,WAAW;IACX,eAAe;IACf,6BAA6B;IAC7B,2BAA2B;EAgB7B;;EAdE;MACE,qBAAqB;IAMvB;;EAJE;QACE,2BAA2B;QAC3B,0BAA0B;MAC5B;;EAGF;MACE,6BAA6B;MAC7B,WAAW;MACX,YAAY;IACd;;EAIA;MACE,cAAc;IAChB;;EAIA;MACE,UAAU;IACZ;;EAGF;IACE,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;EACb;;EAEA;IACE,mCAAmC;IACnC,yBAAyB;IACzB,kBAAkB;IAClB,uBAAuB;IACvB,YAAY;IACZ,eAAe;IACf,cAAc;IACd,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,aAAa;IACb,mBAAmB;EAMrB;;EALE;MACE,4BAA4B;MAC5B,yBAAyB;MACzB,kBAAkB;IACpB;;EAGF;IACE,yBAAyB;EAC3B;;EACA;IACE,qBAAqB;IACrB,yBAAyB;IACzB,kCAAkC;EACpC;;EACA;IACE,kCAAkC;EACpC;;EACA;IACE,qBAAqB;EACvB;;EAGE;MACE,UAAU;MACV,WAAW;IACb;;EAEA;MACE,yBAAyB;MACzB,kBAAkB;IACpB;;EAEA;;OAEG;;EAEH;MACE,uBAAuB;IACzB;;EAEA;MAGE,aAAa;IACf;;EAIA;MACE,iBAAiB;MACjB,gBAAgB;MAChB,YAAY;IACd","sourcesContent":[":global {\n  @import url('https://fonts.googleapis.com/css?family=Montserrat');\n\n  @font-face {\n    font-family: 'Roboto';\n    font-style: normal;\n    font-weight: 400;\n    src:\n      local('Roboto'),\n      local('Roboto-Regular'),\n      url(https://fonts.gstatic.com/s/roboto/v15/2UX7WLTfW3W8TclTUvlFyQ.woff)\n        format('woff');\n  }\n\n  * {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n  *:before,\n  *:after {\n    -webkit-box-sizing: border-box;\n    -moz-box-sizing: border-box;\n    box-sizing: border-box;\n  }\n\n  html {\n    height: 100%;\n    body {\n      font-family: 'Roboto', sans-serif;\n      background: #f6f6f7;\n      justify-content: center;\n      flex-direction: column;\n      text-align: center;\n      height: auto;\n      margin: 0;\n      position: relative;\n      color: #1b2432;\n    }\n  }\n\n  input:-webkit-autofill,\n  textarea:-webkit-autofill,\n  select:-webkit-autofill {\n    background-color: transparent !important;\n    -webkit-box-shadow: 0 0 0 30px white inset;\n    -webkit-text-fill-background-color: transparent !important;\n  }\n\n  input[type='text']:disabled {\n    background: #f6f6f7;\n    font-family: Roboto-Regular;\n    font-size: 15px;\n    color: #6d717a;\n    opacity: 1 !important;\n  }\n\n  input[type='text'],\n  input[type='password'],\n  textarea,\n  select {\n    outline: none;\n  }\n\n  a {\n    text-decoration: none;\n    color: #000000;\n  }\n\n  h1 {\n    font-size: 40px;\n    font-weight: 300;\n  }\n\n  h2 {\n    font-size: 17px;\n    font-weight: 500;\n    line-height: 20px;\n    margin: 0;\n  }\n\n  .pageWrapper {\n    text-align: left;\n\n    &.pageWrapperThin {\n      margin: auto;\n    }\n\n    &.pageWrapperMid {\n      max-width: 1120px;\n      margin: auto;\n    }\n  }\n\n  .react-autosuggest__container {\n    position: relative;\n  }\n\n  .react-autosuggest__suggestions-container {\n    display: none;\n  }\n\n  .react-autosuggest__suggestions-container--open {\n    display: block;\n    position: absolute;\n    z-index: 2;\n    margin-top: 5px;\n    box-shadow: none;\n    border: 1px solid #c6c8cc;\n    border-radius: 5px;\n  }\n\n  .react-autosuggest__suggestions-list {\n    margin: 0;\n    padding: 0;\n    list-style-type: none;\n  }\n\n  .react-autosuggest__suggestion {\n    cursor: pointer;\n    display: block;\n  }\n\n  .success-message,\n  .error-message {\n    background-color: #1b2432 !important;\n    color: #fff;\n    font-size: 15px;\n    padding: 13px 16px !important;\n    min-width: 375px !important;\n\n    > div {\n      padding: 0 !important;\n\n      > span {\n        font-weight: 600 !important;\n        font-size: 15px !important;\n      }\n    }\n\n    svg {\n      margin-right: 16px !important;\n      width: 26px;\n      height: 26px;\n    }\n  }\n\n  .success-message {\n    svg {\n      color: #40e8af;\n    }\n  }\n\n  .error-message {\n    svg {\n      color: red;\n    }\n  }\n\n  .recommendedItemContainer {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n  }\n\n  .recommended {\n    background: rgba(18, 218, 159, 0.1);\n    border: 1px solid #12da9f;\n    border-radius: 4px;\n    width: 105px !important;\n    height: 24px;\n    font-size: 13px;\n    color: #1b2432;\n    letter-spacing: 0;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  .menuItem {\n    display: flex;\n    align-items: center;\n    svg {\n      margin-right: 5px !important;\n      border: 1px solid #dddee0;\n      border-radius: 50%;\n    }\n  }\n\n  .rc-color-picker {\n    z-index: 99999 !important;\n  }\n  .rc-color-picker-panel {\n    opacity: 1 !important;\n    z-index: 99999 !important;\n    background-color: white !important;\n  }\n  .rc-color-picker-panel-inner {\n    background-color: white !important;\n  }\n  label[data-shrink='true'] {\n    z-index: 1 !important;\n  }\n\n  .styled-scrollbars {\n    &::-webkit-scrollbar {\n      width: 8px;\n      height: 8px;\n    }\n\n    &::-webkit-scrollbar-thumb {\n      background-color: #e0e2e6;\n      border-radius: 8px;\n    }\n\n    /* &::-webkit-scrollbar-track {\n      background: #f6f6f7;\n    } */\n\n    &::-webkit-scrollbar-track-piece {\n      background: transparent;\n    }\n\n    &::-webkit-resizer,\n    &::-webkit-scrollbar-button,\n    &::-webkit-scrollbar-corner {\n      display: none;\n    }\n  }\n\n  .companyEmployeePopup {\n    .react-autosuggest__suggestions-list {\n      max-height: 200px;\n      overflow-y: auto;\n      width: 305px;\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
